export default __webpack_public_path__ + "static/media/DogDefault2.b73bfdd5.jpg";